import React, { useCallback, useEffect, useState } from 'react'
import { routes } from '@linqpal/models'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import Spacer from '../../ui/atoms/Spacer'
import ErrorText from '../Auth/ErrorText'
import SignupStore from '../Auth/stores/SignupStore'
import Layout from '../Auth/Layout'
import { dispatcher, pathFactory, paths } from '../links'
import SubmitButton from '../Auth/SubmitButton'
import { useTranslation } from 'react-i18next'
import RootStore from '../../store/RootStore'
import { validateEmail } from '@linqpal/models/src/helpers/validations'
import { invitationTypes } from '@linqpal/models/src/dictionaries'
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'
import { CustomerAccountType } from '@linqpal/models/src/dictionaries/customerAccountType'

export default ({ navigation, route }) => {
  const code = route.params?.code
  const { setLogin } = SignupStore
  const { t } = useTranslation('auth')

  const [errorMessage, setErrorMessage] = useState({
    message: 'Please wait...',
    color: commonColors.primary,
  })
  const processInvitation = useCallback(async () => {
    await RootStore.logOut()
    routes.invitation
      .check(code)
      .then((inv) => {
        if (inv.result === 'expired') {
          setErrorMessage({
            color: commonColors.accent,
            message: 'Invitation has expired',
          })
        } else {
          const {
            _id,
            email,
            firstName,
            lastName,
            login,
            type,
            phone,
            metadata,
            company,
            company_id,
            account,
          } = inv.invitation
          const defaultSignup: string =
            RootStore.branding?.settings?.defaultSignupMethod
          SignupStore.setValue(
            'type',
            defaultSignup === 'email' || validateEmail(login)
              ? 'password'
              : 'code',
          )
          SignupStore.setLogin(login)
          SignupStore.setValue('email', email)
          SignupStore.setValue(
            'phone',
            isValidPhoneNumber(phone || '', 'US')
              ? parsePhoneNumber(phone, 'US').nationalNumber
              : '',
          )
          SignupStore.setValue('firstName', firstName)
          SignupStore.setValue('lastName', lastName)
          SignupStore.setValue('invitation', _id)
          SignupStore.setValue('isInvitation', true)
          SignupStore.setValue('invitationType', type)

          if (metadata) {
            if (metadata.guestCustomerId) {
              SignupStore.setValue(
                'guest_customer_id',
                metadata.guestCustomerId,
              )
            }

            if (metadata.businessName) {
              SignupStore.setValue('company_name', metadata.businessName)
            }
          }

          if (
            [
              invitationTypes.GETPAID_INVITE,
              invitationTypes.CREDIT_INVITE,
            ].includes(type)
          ) {
            SignupStore.setValue('company_name', inv.invitation.company?.name)
          }

          if (type === invitationTypes.SUPPLIER_INVITE_CUSTOMER) {
            if (
              account?.type === CustomerAccountType.IHC &&
              company?.settings?.arAdvance?.isEnabled &&
              company_id
            ) {
              SignupStore.setValue('factoringSupplierId', company_id)
            }
          }
          RootStore.initRouteParams({ invitationType: type })

          setErrorMessage({ message: '', color: commonColors.accent })
          const action = dispatcher(pathFactory('Auth.SignUp'))
          navigation.replace(action.name, action.params)
        }
      })
      .catch((e) => {
        console.log(e)
        setErrorMessage({
          message: e.data?.message || 'Wrong invitation data',
          color: commonColors.accent,
        })
      })
  }, [code, navigation])
  useEffect(() => {
    if (code) {
      processInvitation()
    } else {
      setErrorMessage({
        message: 'Invitation unsuccessful',
        color: commonColors.accent,
      })
    }
  }, [code, processInvitation, setLogin])

  return (
    <React.Fragment>
      {errorMessage.message && (
        <Layout>
          <Spacer />
          <ErrorText color={errorMessage.color}>
            {errorMessage.message}
          </ErrorText>
          <Spacer />
          <SubmitButton onPress={() => navigation.replace(paths.Home._self)}>
            {t('goToHomePage')}
          </SubmitButton>
        </Layout>
      )}
    </React.Fragment>
  )
}
